var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0007 6.66732H14.1673V5.00065C14.1673 2.70065 12.3007 0.833984 10.0007 0.833984C7.70065 0.833984 5.83398 2.70065 5.83398 5.00065V6.66732H5.00065C4.08398 6.66732 3.33398 7.41732 3.33398 8.33398V16.6673C3.33398 17.584 4.08398 18.334 5.00065 18.334H15.0007C15.9173 18.334 16.6673 17.584 16.6673 16.6673V8.33398C16.6673 7.41732 15.9173 6.66732 15.0007 6.66732ZM10.0007 14.1673C9.08398 14.1673 8.33398 13.4173 8.33398 12.5007C8.33398 11.584 9.08398 10.834 10.0007 10.834C10.9173 10.834 11.6673 11.584 11.6673 12.5007C11.6673 13.4173 10.9173 14.1673 10.0007 14.1673ZM7.50065 5.00065V6.66732H12.5007V5.00065C12.5007 3.61732 11.384 2.50065 10.0007 2.50065C8.61732 2.50065 7.50065 3.61732 7.50065 5.00065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ef604c120d6479816d798a9736dc63cd.svg";
export { ForwardRef as ReactComponent };